<template>
  <Breadcrumbs
      title="Invoice Summary Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Invoice Summary Report', path: '/invoice-summary-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <invoiceSummaryForm />
    </div>
  </div>
</template>

<script>
import invoiceSummaryForm from "@/pages/report/invoice_summery/invoiceSummeryForm.vue";

export default {
  name: 'indexList',
  components: {
    invoiceSummaryForm,
  },
}
</script>
